export default {
  FARM_ASSURANCE: 'F',
  ORGANIC_ASSURANCE: 'O',
  RED_TRACTOR: 'RT',
  SOIL_ASSOCIATION: 'SA'
}
